export const ACCESS_HEADER_NAME = {
    accessToken: 'x-access-token',
    publicKey: 'x-user-public-key',
};
export class AccessToken {
    static validateJWT(jwt) {
        if (!jwt)
            return null;
        const [rawHead, rawBody, signature] = jwt.split(".");
        if (!rawHead || !rawBody || !signature)
            return null;
        if (2 + rawHead.length + rawBody.length + signature.length !== jwt.length)
            return null;
        try {
            const head = JSON.parse(atob(rawHead));
            const body = JSON.parse(atob(rawBody));
            return { head, body, signature };
        }
        catch (_a) {
            return null;
        }
    }
    static extractData(body) {
        try {
            return JSON.parse(atob(body.meta));
        }
        catch (_a) {
            return null;
        }
    }
    static extractMeta(body) {
        try {
            const { meta } = JSON.parse(atob(body.meta));
            return meta;
        }
        catch (_a) {
            return null;
        }
    }
    static getAccessHeaderNameByToken(token) {
        return !!AccessToken.validateJWT(token) ? ACCESS_HEADER_NAME.accessToken : ACCESS_HEADER_NAME.publicKey;
    }
}
//# sourceMappingURL=../../src/lib/helper/access-token.js.map